import { IProjectInfo } from 'library/ts/IProjectInfo';

/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Project info object with replaceable tokens and their values replaced at build time. This object is a copy of the one from project.json used by Node scripts.
 * NOTE: This approach (maintaining 2 identical objects for TS and Node) is going to be replaced as soon as we find a solution for Babel not transpling const to var.
 * @type {IProjectInfo}
 */
export const ProjectInfo: IProjectInfo = {
	release_version: '$APP_VERSION_VALUE_REPLACED_AT_BUILD_TIME$',
	app_name: {
		all: {
			token: '$APP_NAME_ALL$',
			value: 'all'
		},
		tag: {
			token: '$APP_NAME_TAG$',
			value: 'tag'
		},
		skin: {
			token: '$APP_NAME_SKIN_DESKTOP$',
			value: 'skin'
		},
		skin_mobile: {
			token: '$APP_NAME_SKIN_MOBILE$',
			value: 'skin_mobile'
		},
		skin_plugin_sidebar: {
			token: '$APP_NAME_SKIN_PLUGIN_SIDEBAR$',
			value: 'skin_plugin_sidebar'
		},
		skin_plugin_multi_cam: {
			token: '$APP_NAME_SKIN_PLUGIN_MULTI_CAM$',
			value: 'skin_plugin_multi_cam'
		},
		skin_plugin_multi_stream: {
			token: '$APP_NAME_SKIN_PLUGIN_MULTI_STREAM$',
			value: 'skin_plugin_multi_stream'
		},
		skin_plugin_related_videos: {
			token: '$APP_NAME_SKIN_PLUGIN_RELATED_VIDEOS$',
			value: 'skin_plugin_related_videos'
		},
		skin_plugin_sample: {
			token: '$APP_NAME_SKIN_PLUGIN_SAMPLE$',
			value: 'skin_plugin_sample'
		},
		tag_plugin_sample: {
			token: '$APP_NAME_TAG_PLUGIN_SAMPLE$',
			value: 'tag_plugin_sample'
		},
		tag_plugin_data_service: {
			token: '$APP_NAME_TAG_PLUGIN_DATA_SERVICE$',
			value: 'tag_plugin_data_service'
		},
		tag_plugin_nerd_mode: {
			token: '$APP_NAME_TAG_PLUGIN_NERD_MODE$',
			value: 'tag_plugin_nerd_mode'
		},
		tag_plugin_mobile_web_ui: {
			token: '$APP_NAME_TAG_PLUGIN_MOBILE_WEB_UI$',
			value: 'tag_plugin_mobile_web_ui'
		},
		iframe: {
			token: '$APP_NAME_IFRAME$',
			value: 'iframe'
		},
		iframe_php: {
			token: '$APP_NAME_IFRAME$',
			value: 'iframe_php'
		},
		iframe_companion: {
			token: '$APP_NAME_IFRAME_COMPANION$',
			value: 'iframe_companion'
		}
	},
	app_storage_prefix: {
		smart_tag: {
			token: '$STORAGE_NAME_SMART_TAG$',
			value: 'smart-tag'
		}
	},
	app_compile_time: {
		tag: {
			token: '$COMPILE_TIME_TAG$'
		},
		skin: {
			token: '$COMPILE_TIME_SKIN_DESKTOP$'
		},
		skin_mobile: {
			token: '$COMPILE_TIME_SKIN_MOBILE$'
		},
		skin_plugin_sidebar: {
			token: '$COMPILE_TIME_SKIN_PLUGIN_SIDEBAR$'
		},
		skin_plugin_multi_cam: {
			token: '$COMPILE_TIME_SKIN_PLUGIN_MULTI_CAM$'
		},
		skin_plugin_multi_stream: {
			token: '$COMPILE_TIME_SKIN_PLUGIN_MULTI_STREAM$'
		},
		skin_plugin_related_videos: {
			token: '$COMPILE_TIME_SKIN_PLUGIN_RELATED_VIDEOS$'
		},
		skin_plugin_sample: {
			token: '$COMPILE_TIME_SKIN_PLUGIN_SAMPLE$'
		},
		tag_plugin_sample: {
			token: '$COMPILE_TIME_TAG_PLUGIN_SAMPLE$'
		},
		tag_plugin_data_service: {
			token: '$COMPILE_TIME_TAG_PLUGIN_DATA_SERVICE$'
		},
		tag_plugin_nerd_mode: {
			token: '$COMPILE_TIME_TAG_PLUGIN_NERD_MODE$'
		},
		tag_plugin_mobile_web_ui: {
			token: '$COMPILE_TIME_TAG_PLUGIN_MOBILE_WEB_UI$'
		},
		iframe: {
			token: '$COMPILE_TIME_IFRAME$'
		},
		iframe_php: {
			token: '$COMPILE_TIME_IFRAME_PHP$'
		},
		iframe_companion: {
			token: '$COMPILE_TIME_IFRAME_COMPANION$'
		}
	},
	app_source_dir: {
		tag: {
			token: '$SOURCE_DIR_SMART_TAG$',
			value: './src/tag/'
		},
		skin: {
			token: '$SOURCE_DIR_SKIN$',
			value: './src/skin/'
		},
		skin_mobile: {
			token: '$SOURCE_DIR_SKIN_MOBILE$',
			value: './src/skin_mobile/'
		},
		skin_plugin_sidebar: {
			token: '$SOURCE_DIR_SKIN_PLUGIN_SIDEBAR$',
			value: './src/plugins/skin/plugin_sidebar/'
		},
		skin_plugin_multi_cam: {
			token: '$SOURCE_DIR_SKIN_PLUGIN_MULTI_CAM$',
			value: './src/plugins/skin/plugin_multi_cam/'
		},
		skin_plugin_multi_stream: {
			token: '$SOURCE_DIR_SKIN_PLUGIN_MULTI_STREAM$',
			value: './src/plugins/skin/plugin_multi_stream/'
		},
		skin_plugin_related_videos: {
			token: '$SOURCE_DIR_SKIN_PLUGIN_RELATED_VIDEOS$',
			value: './src/plugins/skin/plugin_related_videos/'
		},
		skin_plugin_sample: {
			token: '$SOURCE_DIR_SKIN_PLUGIN_SAMPLE$',
			value: './src/plugins/skin/plugin_sample/'
		},
		tag_plugin_sample: {
			token: '$SOURCE_DIR_TAG_PLUGIN_SAMPLE$',
			value: './src/plugins/tag/plugin_sample/'
		},
		tag_plugin_data_service: {
			token: '$SOURCE_DIR_TAG_PLUGIN_DATA_SERVICE$',
			value: './src/plugins/tag/plugin_data_service/'
		},
		tag_plugin_nerd_mode: {
			token: '$SOURCE_DIR_TAG_PLUGIN_NERD_MODE$',
			value: './src/plugins/tag/plugin_nerd_mode/'
		},
		tag_plugin_mobile_web_ui: {
			token: '$SOURCE_DIR_TAG_PLUGIN_MOBILE_WEB_UI$',
			value: './src/plugins/tag/plugin_mobile_web_ui/'
		},
		iframe: {
			token: '$SOURCE_DIR_IFRAME$',
			value: './src/iframe/'
		},
		iframe_php: {
			token: '$SOURCE_DIR_IFRAME_PHP$',
			value: './src/iframe/'
		},
		iframe_companion: {
			token: '$SOURCE_DIR_IFRAME_COMPANION$',
			value: './src/iframe_companion/'
		}
	},
	app_output_dir: {
		tag: {
			token: '$DIR_SMART_TAG$',
			value: 'smart-tag'
		},
		skin: {
			token: '$DIR_SKIN$',
			value: 'smart-tag-skin'
		},
		skin_mobile: {
			token: '$DIR_SKIN_MOBILE$',
			value: 'smart-tag-skin-mobile'
		},
		skin_plugin_sidebar: {
			token: '$DIR_SKIN_PLUGIN_SIDEBAR$',
			value: 'smart-tag-skin-plugin-sidebar'
		},
		skin_plugin_multi_cam: {
			token: '$DIR_SKIN_PLUGIN_MULTI_CAM$',
			value: 'smart-tag-skin-plugin-multi-cam'
		},
		skin_plugin_multi_stream: {
			token: '$DIR_SKIN_PLUGIN_MULTI_STREAM$',
			value: 'smart-tag-skin-plugin-multi-stream'
		},
		skin_plugin_related_videos: {
			token: '$DIR_SKIN_PLUGIN_RELATED_VIDEOS$',
			value: 'smart-tag-skin-plugin-related-videos'
		},
		skin_plugin_sample: {
			token: '$DIR_SKIN_PLUGIN_SAMPLE$',
			value: 'smart-tag-skin-plugin-sample'
		},
		tag_plugin_sample: {
			token: '$DIR_TAG_PLUGIN_SAMPLE$',
			value: 'smart-tag-plugin-sample'
		},
		tag_plugin_data_service: {
			token: '$DIR_TAG_PLUGIN_DATA_SERVICE$',
			value: 'smart-tag-data-service'
		},
		tag_plugin_nerd_mode: {
			token: '$DIR_TAG_PLUGIN_NERD_MODE$',
			value: 'smart-tag-nerd-mode'
		},
		tag_plugin_mobile_web_ui: {
			token: '$DIR_TAG_PLUGIN_MOBILE_WEB_UI$',
			value: 'smart-tag-mobile-web-ui'
		},
		iframe: {
			token: '$DIR_IFRAME$',
			value: 'iframe'
		},
		iframe_php: {
			token: '$DIR_IFRAME_PHP$',
			value: 'iframe'
		},
		iframe_companion: {
			token: '$DIR_IFRAME_COMPANION$',
			value: 'iframe'
		}
	},
	app_namespace: {
		tag: {
			token: '$SMART_TAG_NAMESPACE$',
			value: 'SmartTag'
		}
	},
	app_output_file: {
		tag: {
			js: {
				min: {
					token: '$SMART_TAG_JS_FILE_NAME_MIN$',
					value: 'smart.tag.js'
				}
			}
		},
		skin: {
			js: {
				min: {
					token: '$SKIN_JS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.js'
				}
			},
			css: {
				min: {
					token: '$SKIN_CSS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.css',
					pplus: {
						token: '$SKIN_CSS_FILE_NAME_MIN_PPLUS$',
						value: 'smart.tag.skin.pplus.css'
					},
					plutotv: {
						token: '$SKIN_CSS_FILE_NAME_MIN_PLUTOTV$',
						value: 'smart.tag.skin.plutotv.css'
					},
					cbs: {
						token: '$SKIN_CSS_FILE_NAME_MIN_CBS$',
						value: 'smart.tag.skin.cbs.css'
					}
				}
			}
		},
		skin_mobile: {
			js: {
				min: {
					token: '$SKIN_MOBILE_JS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.mobile.js'
				}
			},
			css: {
				min: {
					token: '$SKIN_MOBILE_CSS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.mobile.css',
					pplus: {
						token: '$SKIN_MOBILE_CSS_FILE_NAME_MIN_PPLUS$',
						value: 'smart.tag.skin.mobile.pplus.css'
					},
					plutotv: {
						token: '$SKIN_MOBILE_CSS_FILE_NAME_MIN_PLUTOTV$',
						value: 'smart.tag.skin.mobile.plutotv.css'
					},
					cbs: {
						token: '$SKIN_MOBILE_CSS_FILE_NAME_MIN_CBS$',
						value: 'smart.tag.skin.mobile.cbs.css'
					}
				}
			}
		},
		skin_plugin_sidebar: {
			js: {
				min: {
					token: '$SKIN_PLUGIN_SIDEBAR_JS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.plugin.sidebar.js'
				}
			},
			css: {
				min: {
					token: '$SKIN_PLUGIN_SIDEBAR_CSS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.plugin.sidebar.css',
					pplus: {
						token: '$SKIN_PLUGIN_SIDEBAR_CSS_FILE_NAME_MIN_PPLUS$',
						value: 'smart.tag.skin.plugin.sidebar.pplus.css'
					},
					plutotv: {
						token: '$SKIN_PLUGIN_SIDEBAR_CSS_FILE_NAME_MIN_PLUTOTV$',
						value: 'smart.tag.skin.plugin.sidebar.plutotv.css'
					},
					cbs: {
						token: '$SKIN_PLUGIN_SIDEBAR_CSS_FILE_NAME_MIN_CBS$',
						value: 'smart.tag.skin.plugin.sidebar.cbs.css'
					}
				}
			}
		},
		skin_plugin_multi_cam: {
			js: {
				min: {
					token: '$SKIN_PLUGIN_MULTI_CAM_JS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.plugin.multi.cam.js'
				}
			},
			css: {
				min: {
					token: '$SKIN_PLUGIN_MULTI_CAM_CSS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.plugin.multi.cam.css',
					pplus: {
						token: '$SKIN_PLUGIN_MULTI_CAM_CSS_FILE_NAME_MIN_PPLUS$',
						value: 'smart.tag.skin.plugin.multi.cam.pplus.css'
					},
					plutotv: {
						token: '$SKIN_PLUGIN_MULTI_CAM_CSS_FILE_NAME_MIN_PLUTOTV$',
						value: 'smart.tag.skin.plugin.multi.cam.plutotv.css'
					},
					cbs: {
						token: '$SKIN_PLUGIN_MULTI_CAM_CSS_FILE_NAME_MIN_CBS$',
						value: 'smart.tag.skin.plugin.multi.cam.cbs.css'
					}
				}
			}
		},
		skin_plugin_multi_stream: {
			js: {
				min: {
					token: '$SKIN_PLUGIN_MULTI_STREAM_JS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.plugin.multi.stream.js'
				}
			},
			css: {
				min: {
					token: '$SKIN_PLUGIN_MULTI_STREAM_CSS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.plugin.multi.stream.css',
					pplus: {
						token: '$SKIN_PLUGIN_MULTI_STREAM_CSS_FILE_NAME_MIN_PPLUS$',
						value: 'smart.tag.skin.plugin.multi.stream.pplus.css'
					},
					plutotv: {
						token: '$SKIN_PLUGIN_MULTI_STREAM_CSS_FILE_NAME_MIN_PLUTOTV$',
						value: 'smart.tag.skin.plugin.multi.stream.plutotv.css'
					},
					cbs: {
						token: '$SKIN_PLUGIN_MULTI_STREAM_CSS_FILE_NAME_MIN_CBS$',
						value: 'smart.tag.skin.plugin.multi.stream.cbs.css'
					}
				}
			}
		},
		skin_plugin_related_videos: {
			js: {
				min: {
					token: '$SKIN_PLUGIN_RELATED_VIDEOS_JS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.plugin.related.videos.js'
				}
			},
			css: {
				min: {
					token: '$SKIN_PLUGIN_RELATED_VIDEOS_CSS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.plugin.related.videos.css',
					pplus: {
						token: '$SKIN_PLUGIN_RELATED_VIDEOS_CSS_FILE_NAME_MIN_PPLUS$',
						value: 'smart.tag.skin.plugin.related.videos.pplus.css'
					},
					plutotv: {
						token: '$SKIN_PLUGIN_RELATED_VIDEOS_CSS_FILE_NAME_MIN_PLUTOTV$',
						value: 'smart.tag.skin.plugin.related.videos.plutotv.css'
					},
					cbs: {
						token: '$SKIN_PLUGIN_RELATED_VIDEOS_CSS_FILE_NAME_MIN_CBS$',
						value: 'smart.tag.skin.plugin.related.videos.cbs.css'
					}
				}
			}
		},
		skin_plugin_sample: {
			js: {
				min: {
					token: '$SKIN_PLUGIN_SAMPLE_JS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.plugin.sample.js'
				}
			},
			css: {
				min: {
					token: '$SKIN_PLUGIN_SAMPLE_CSS_FILE_NAME_MIN$',
					value: 'smart.tag.skin.plugin.sample.css',
					pplus: {
						token: '$SKIN_PLUGIN_SAMPLE_CSS_FILE_NAME_MIN_PPLUS$',
						value: 'smart.tag.skin.plugin.sample.pplus.css'
					},
					plutotv: {
						token: '$SKIN_PLUGIN_SAMPLE_CSS_FILE_NAME_MIN_PLUTOTV$',
						value: 'smart.tag.skin.plugin.sample.plutotv.css'
					},
					cbs: {
						token: '$SKIN_PLUGIN_SAMPLE_CSS_FILE_NAME_MIN_CBS$',
						value: 'smart.tag.skin.plugin.sample.cbs.css'
					}
				}
			}
		},
		tag_plugin_sample: {
			js: {
				min: {
					token: '$TAG_PLUGIN_SAMPLE_JS_FILE_NAME_MIN$',
					value: 'smart.tag.plugin.sample.js'
				}
			},
			css: {
				min: {
					token: '$TAG_PLUGIN_SAMPLE_CSS_FILE_NAME_MIN$',
					value: 'smart.tag.plugin.sample.css'
				}
			}
		},
		tag_plugin_data_service: {
			js: {
				min: {
					token: '$TAG_PLUGIN_DATA_SERVICE_JS_FILE_NAME_MIN$',
					value: 'smart.tag.data.service.js'
				}
			},
			css: {
				min: {
					token: '$TAG_PLUGIN_DATA_SERVICE_CSS_FILE_NAME_MIN$',
					value: 'smart.tag.data.service.css'
				}
			}
		},
		tag_plugin_nerd_mode: {
			js: {
				min: {
					token: '$TAG_PLUGIN_NERD_MODE_JS_FILE_NAME_MIN$',
					value: 'smart.tag.nerd.mode.js'
				}
			},
			css: {
				min: {
					token: '$TAG_PLUGIN_NERD_MODE_CSS_FILE_NAME_MIN$',
					value: 'smart.tag.nerd.mode.css'
				}
			}
		},
		tag_plugin_mobile_web_ui: {
			js: {
				min: {
					token: '$TAG_PLUGIN_MOBILE_WEB_UI_JS_FILE_NAME_MIN$',
					value: 'smart.tag.mobile.web.ui.js'
				}
			},
			css: {
				min: {
					token: '$TAG_PLUGIN_MOBILE_WEB_UI_CSS_FILE_NAME_MIN$',
					value: 'smart.tag.mobile.web.ui.css',
					pplus: {
						token: '$TAG_PLUGIN_MOBILE_WEB_UI_CSS_FILE_NAME_MIN_PPLUS$',
						value: 'smart.tag.mobile.web.ui.pplus.css'
					},
					plutotv: {
						token: '$TAG_PLUGIN_MOBILE_WEB_UI_CSS_FILE_NAME_MIN_PLUTOTV$',
						value: 'smart.tag.mobile.web.ui.plutotv.css'
					},
					cbs: {
						token: '$TAG_PLUGIN_MOBILE_WEB_UI_CSS_FILE_NAME_MIN_CBS$',
						value: 'smart.tag.mobile.web.ui.cbs.css'
					}
				}
			}
		},
		iframe: {
			php: {
				token: '$IFRAME_PHP_FILE_NAME$',
				value: 'player.php'
			},
			js: {
				min: {
					token: '$IFRAME_JS_FILE_NAME_MIN$',
					value: 'player.js'
				}
			}
		},
		iframe_php: {
			php: {
				token: '$IFRAME_PHP_FILE_NAME$',
				value: 'player.php'
			}
		},
		iframe_companion: {
			js: {
				min: {
					token: '$IFRAME_COMPANION_JS_FILE_NAME_MIN$',
					value: 'player.companion.js'
				}
			}
		}
	},
	envelope: {
		localhost: {
			token: '$ENVELOPE_NAME_LOCALHOST$',
			value: 'localhost'
		},
		automation: {
			token: '$ENVELOPE_NAME_AUTOMATION$',
			value: 'automation'
		},
		platypus: {
			token: '$ENVELOPE_NAME_PLATYPUS$',
			value: 'platypus'
		},
		dev: {
			token: '$ENVELOPE_NAME_DEV$',
			value: 'dev'
		},
		branch: {
			token: '$ENVELOPE_NAME_BRANCH$',
			value: 'branch'
		},
		stage: {
			token: '$ENVELOPE_NAME_STAGE$',
			value: 'stage'
		},
		'stage-hub': {
			token: '$ENVELOPE_NAME_STAGE_HUB$',
			value: 'stage-hub'
		},
		perf: {
			token: '$ENVELOPE_NAME_PERF$',
			value: 'perf'
		},
		standby: {
			token: '$ENVELOPE_NAME_STANDBY$',
			value: 'standby'
		},
		preview: {
			token: '$ENVELOPE_NAME_PREVIEW$',
			value: 'preview'
		},
		prod: {
			token: '$ENVELOPE_NAME_PROD$',
			value: 'prod'
		}
	},
	envelope_output_dir: {
		localhost: {
			token: '$ENVELOPE_OUT_DIR_LOCALHOST$',
			value: 'localhost'
		},
		automation: {
			token: '$ENVELOPE_OUT_DIR_AUTOMATION$',
			value: 'release'
		},
		platypus: {
			token: '$ENVELOPE_OUT_DIR_PLATYPUS$',
			value: 'release'
		},
		dev: {
			token: '$ENVELOPE_OUT_DIR_DEV$',
			value: 'release'
		},
		branch: {
			token: '$ENVELOPE_OUT_DIR_BRANCH$',
			value: 'release'
		},
		stage: {
			token: '$ENVELOPE_OUT_DIR_STAGE$',
			value: 'release'
		},
		perf: {
			token: '$ENVELOPE_OUT_DIR_PERF$',
			value: 'release/latest'
		},
		'stage-hub': {
			token: '$ENVELOPE_OUT_DIR_STAGE_HUB$',
			value: 'release'
		},
		standby: {
			token: '$ENVELOPE_OUT_DIR_STANDBY$',
			value: 'release'
		},
		preview: {
			token: '$ENVELOPE_OUT_DIR_PREVIEW$',
			value: 'release'
		},
		prod: {
			token: '$ENVELOPE_OUT_DIR_PROD$',
			value: 'release'
		}
	},
	domain: {
		localhost: {
			token: '$DOMAIN_LOCALHOST$',
			value: 'localhost'
		},
		automation: {
			token: '$DOMAIN_AUTOMATION$',
			value: 'automation-player-services.cbs.com'
		},
		dev: {
			token: '$DOMAIN_BRANCH$',
			value: 'branch-player-services.cbs.com'
		},
		branch: {
			token: '$DOMAIN_BRANCH$',
			value: 'branch-player-services.cbs.com'
		},
		stage: {
			token: '$DOMAIN_STAGE$',
			value: 'stage-player-services.cbs.com'
		},
		perf: {
			token: '$DOMAIN_PERF$',
			value: 'perf-player-services.cbs.com'
		},
		'stage-hub': {
			token: '$DOMAIN_STAGE_HUB$',
			value: 'stage-hub-player-services.cbs.com'
		},
		preview: {
			token: '$DOMAIN_PREVIEW$',
			value: 'preview-player-services.cbs.com'
		},
		prod: {
			token: '$DOMAIN_PROD$',
			value: 'player-services.cbs.com'
		}
	},
	dependencies: {
		bundle: {
			tag: {
				dir: {
					token: '$TAG_DEPENDENCIES_DIR_NAME$',
					value: 'assets/dependencies'
				},
				player: {
					version: {
						player_version_token: '$TAG_PLAYER_VERSION$',
						value: {
							localhost: '2.62.1',
							automation: '2.62.1',
							platypus: '2.62.1',
							dev: '2.62.1',
							branch: '2.62.1',
							stage: '2.62.1',
							'stage-hub': '2.62.1',
							standby: '2.62.1',
							preview: '2.62.1',
							prod: '2.62.1',
							perf: '2.62.1'
						}
					},
					dir: {
						source: {
							token: '$TAG_PLAYER_DEPENDENCY_DIR$',
							value: 'vtg/avia'
						},
						output: {
							token: '$TAG_PLAYER_BUNDLE_DIR$',
							value: 'vtg/avia'
						}
					},
					blank_mp4: {
						dir: {
							source: {
								token: '$TAG_PLAYER_DEPENDENCY_BLANK_MP4_DIR$',
								value: 'vtg'
							},
							output: {
								token: '$TAG_PLAYER_BUNDLE_BLANK_MP4_DIR$',
								value: 'vtg'
							}
						},
						filename: {
							token: '$TAG_PLAYER_DEPENDENCY_BLANK_MP4_FILENAME$',
							value: 'uvp_blank.mp4'
						}
					},
					hlsjs: {
						dir: {
							source: {
								token: '$TAG_PLAYER_DEPENDENCY_HLSJS_DIR$',
								value: 'hls.js/1.6.15'
							},
							output: {
								token: '$TAG_PLAYER_BUNDLE_HLSJS_DIR$',
								value: 'hls.js/1.6.15'
							}
						},
						filename: {
							token: '$TAG_PLAYER_DEPENDENCY_HLSJS_FILENAME$',
							value: 'hls.min.js'
						}
					},
					shaka: {
						dir: {
							source: {
								token: '$TAG_PLAYER_DEPENDENCY_SHAKA_DIR$',
								value: 'shaka/4.16.24'
							},
							output: {
								token: '$TAG_PLAYER_BUNDLE_SHAKA_DIR$',
								value: 'shaka/4.16.24'
							}
						},
						filename: {
							token: '$TAG_PLAYER_DEPENDENCY_SHAKA_FILENAME$',
							value: 'shaka-player.compiled.js'
						}
					},
					omsdk: {
						dir: {
							source: {
								token: '$TAG_PLAYER_DEPENDENCY_OMSDK_DIR$',
								value: 'omsdk/1.6.6'
							},
							output: {
								token: '$TAG_PLAYER_BUNDLE_OMSDK_DIR$',
								value: 'omsdk/1.6.6'
							}
						},
						filename: {
							service: {
								token: '$TAG_PLAYER_DEPENDENCY_OMSDK_SERVICE_FILENAME$',
								value: 'omweb-v1.js'
							},
							sessionClient: {
								token: '$TAG_PLAYER_DEPENDENCY_OMSDK_SESSION_CLIENT_FILENAME$',
								value: 'omid-session-client-v1.js'
							}
						}
					}
				}
			}
		},
		ima: {
			namespace: {
				token: '$IMA3_NAMESPACE$',
				value: 'google.ima.settings'
			},
			url: {
				regular: {
					token: '$IMA3_URL_NORMAL$',
					value: 'https://s0.2mdn.net/instream/html5/ima3.js'
				}
			}
		},
		ima_dai: {
			namespace: {
				token: '$IMA_DAI_NAMESPACE$',
				value: 'google.ima.dai'
			},
			url: {
				regular: {
					token: '$IMA_DAI_URL_NORMAL$',
					value: 'https://imasdk.googleapis.com/js/sdkloader/ima3_dai.js'
				}
			}
		},
		player: {
			namespace: {
				token: '$PLAYER_NAMESPACE$',
				value: 'avia'
			},
			url: {
				regular: {
					token: '$PLAYER_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/player/avia.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_FILE_NAME_NORMAL$',
					value: 'avia.min.js'
				}
			}
		},
		player_ui: {
			namespace: {
				token: '$PLAYER_UI_NAMESPACE$',
				value: 'avia.ui'
			},
			url: {
				regular: {
					token: '$PLAYER_UI_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/plugins/ui/avia.ui.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_UI_FILE_NAME_NORMAL$',
					value: 'avia.ui.min.js'
				}
			}
		},
		player_dash_adapter: {
			namespace: {
				token: '$PLAYER_DASH_ADAPTER_NAMESPACE$',
				value: 'avia.dash'
			},
			url: {
				regular: {
					token: '$PLAYER_DASH_ADAPTER_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/plugins/dash/avia.dash.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_DASH_ADAPTER_FILE_NAME_NORMAL$',
					value: 'avia.dash.min.js'
				}
			}
		},
		player_gam_plugin: {
			namespace: {
				token: '$PLAYER_GAM_PLUGIN_NAMESPACE$',
				value: 'avia.gam'
			},
			url: {
				regular: {
					token: '$PLAYER_GAM_PLUGIN_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/plugins/gam/avia.gam.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_GAM_PLUGIN_FILE_NAME_NORMAL$',
					value: 'avia.gam.min.js'
				}
			}
		},
		player_fw_plugin: {
			namespace: {
				token: '$PLAYER_FW_PLUGIN_NAMESPACE$',
				value: 'avia.fw'
			},
			url: {
				regular: {
					token: '$PLAYER_FW_PLUGIN_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/plugins/fw/avia.fw.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_FW_PLUGIN_FILE_NAME_NORMAL$',
					value: 'avia.fw.min.js'
				}
			}
		},
		player_hls_adapter: {
			namespace: {
				token: '$PLAYER_HLS_ADAPTER_NAMESPACE$',
				value: 'avia.hls'
			},
			url: {
				regular: {
					token: '$PLAYER_HLS_ADAPTER_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/plugins/hls/avia.hls.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_HLS_ADAPTER_FILE_NAME_NORMAL$',
					value: 'avia.hls.min.js'
				}
			}
		},
		player_hlsjs_plugin: {
			namespace: {
				token: '$PLAYER_HLSJS_PLUGIN_NAMESPACE$',
				value: 'avia.hlsjs'
			},
			url: {
				regular: {
					token: '$PLAYER_HLSJS_PLUGIN_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/plugins/hlsjs/avia.hlsjs.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_HLSJS_PLUGIN_FILE_NAME_NORMAL$',
					value: 'avia.hlsjs.min.js'
				}
			}
		},
		player_shaka_plugin: {
			namespace: {
				token: '$PLAYER_SHAKA_PLUGIN_NAMESPACE$',
				value: 'avia.shaka'
			},
			url: {
				regular: {
					token: '$PLAYER_SHAKA_PLUGIN_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/plugins/shaka/avia.shaka.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_SHAKA_PLUGIN_FILE_NAME_NORMAL$',
					value: 'avia.shaka.min.js'
				}
			}
		},
		player_lg_plugin: {
			namespace: {
				token: '$PLAYER_LG_PLUGIN_NAMESPACE$',
				value: 'avia.lg'
			},
			url: {
				regular: {
					token: '$PLAYER_LG_PLUGIN_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/extensions/lg/avia.lg.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_LG_PLUGIN_FILE_NAME_NORMAL$',
					value: 'avia.lg.min.js'
				}
			}
		},
		player_samsung_plugin: {
			namespace: {
				token: '$PLAYER_SAMSUNG_PLUGIN_NAMESPACE$',
				value: 'avia.samsung'
			},
			url: {
				regular: {
					token: '$PLAYER_SAMSUNG_PLUGIN_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/extensions/samsung/avia.samsung.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_SAMSUNG_PLUGIN_FILE_NAME_NORMAL$',
					value: 'avia.samsung.min.js'
				}
			}
		},
		player_xbox_plugin: {
			namespace: {
				token: '$PLAYER_XBOX_PLUGIN_NAMESPACE$',
				value: 'avia.xbox'
			},
			url: {
				regular: {
					token: '$PLAYER_XBOX_PLUGIN_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/extensions/xbox/avia.xbox.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_XBOX_PLUGIN_FILE_NAME_NORMAL$',
					value: 'avia.xbox.min.js'
				}
			}
		},
		player_comcast_plugin: {
			namespace: {
				token: '$PLAYER_COMCAST_PLUGIN_NAMESPACE$',
				value: 'avia.comcast'
			},
			url: {
				regular: {
					token: '$PLAYER_COMCAST_PLUGIN_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/extensions/comcast/avia.comcast.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_COMCAST_PLUGIN_FILE_NAME_NORMAL$',
					value: 'avia.comcast.min.js'
				}
			}
		},
		player_hdcp_plugin: {
			namespace: {
				token: '$PLAYER_HDCP_PLUGIN_NAMESPACE$',
				value: 'avia.hdcp'
			},
			url: {
				regular: {
					token: '$PLAYER_HDCP_PLUGIN_URL_NORMAL$',
					value: 'https://avia.vtg.paramount.tech/avia-js/2.62.1/extensions/hdcp/avia.hdcp.min.js'
				}
			},
			file_name: {
				regular: {
					token: '$PLAYER_HDCP_PLUGIN_FILE_NAME_NORMAL$',
					value: 'avia.hdcp.min.js'
				}
			}
		},
		utag_pplus: {
			namespace: {
				token: '$UTAG_NAMESPACE$',
				value: 'utag'
			},
			url: {
				regular: {
					token: '$UTAG_URL_NORMAL$',
					value: 'https://tags.tiqcdn.com/utag/cbsi/pplus/prod/utag.js'
				}
			}
		},
		utag_cbs: {
			namespace: {
				token: '$UTAG_NAMESPACE$',
				value: 'utag'
			},
			url: {
				regular: {
					token: '$UTAG_URL_NORMAL$',
					value: 'https://tags.tiqcdn.com/utag/cbsi/cbstve/prod/utag.js'
				}
			}
		}
	}
};